// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1lQ0w","tabsBox":"styles_tabsBox__v9IWv","createButton":"styles_createButton__28fJQ"};